import { memo, useEffect, useRef } from "react";
import "./CanvasLogo.css";
import Logo from "./logo/Logo";

function CanvasLogo() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const logo = new Logo(canvas);
      logo.draw();
    }
  }, []);

  return (
    <div className="App-header__logo">
      <canvas ref={canvasRef}></canvas>
    </div>
  );
}

export default memo(CanvasLogo);
